import React, { Component } from "react";
import { connect } from "react-redux";

import TopHeader from "./TopHeader/TopHeader";
import HeaderMenu from "./HeaderMenu/HeaderMenu";
import CheckoutHeader from "./CheckoutHeader/CheckoutHeader";
import AddedToCart from "./AddedToCart/AddedToCart";

import { primary_s26_l96 } from "../../shared/lib/colors";

import "./Header.scss";

const login = () => console.log("ciao");
const loginFacebook = () => console.log("ciao");
const createUser = () => console.log("ciao");

class Header extends Component {
  renderBackgroundVersion = (uiVariantBackground) => {
    // console.log(this.props.primaryColor);
    switch (uiVariantBackground) {
      case "1":
        return primary_s26_l96(this.props.primaryColor);
      case "2":
        return "#f6f6f6";
      case "3":
        return "#fff";
      // default:
      //   return primary_s26_l96(this.props.primaryColor);
      default:
        return uiVariantBackground;
    }
  };

  render() {
    const {
      isCheckout,
      login,
      user,
      isAuthenticated,
      phone,
      primaryColor,
      secondaryColor,
      headerMenuOpen,
      loginFacebook,
      createUser,
    } = this.props;

    return (
      <header
        className={`${isCheckout ? "header-checkout" : "header-not-checkout"} ${
          headerMenuOpen ? "menu-open" : "menu-closed"
        }`}
        style={{
          backgroundColor: this.renderBackgroundVersion(
            this.props.uiVariantBackground
          ),
        }}
      >
        <TopHeader
          isCheckout={isCheckout}
          user={user}
          isAuthenticated={isAuthenticated}
          onLogin={login}
          onLoginFacebook={loginFacebook}
          createUser={createUser}
          phone={phone}
          primaryColor={primaryColor}
        />

        {isCheckout ? (
          <CheckoutHeader />
        ) : (
          <HeaderMenu
            user={user}
            isAuthenticated={isAuthenticated}
            onLogin={login}
            phone={phone}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            onLoginFacebook={loginFacebook}
            createUser={createUser}
          />
        )}

        <AddedToCart />
      </header>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user.data,
  isAuthenticated: state.user.authenticated,
  phone: state.store.singleStore.phone,
  primaryColor: state.store.singleStore.brandColor,
  secondaryColor: state.store.singleStore.secondaryColor,
  headerMenuOpen: state.store.singleStore.headerMenuOpen,
  uiVariantBackground: String(state.store.singleStore.background),
});

export default connect(mapStateToProps, { login, loginFacebook, createUser })(
  Header
);
